import { Button, Flex, Typography } from 'antd';

import styles from './styles.module.css';

interface SidebarChartsProps {
	summaryContent?: string;
	summaryLoading?: boolean;
	summaryError?: string;
	onGenerateSummary?: () => void;
}

export default function SidebarCharts({ 
	summaryContent, 
	summaryLoading, 
	summaryError,
	onGenerateSummary
}: SidebarChartsProps) {
	return (
		<Flex
			vertical
			gap={16}
			style={{
				border: '1px solid #d9d9d9',
				borderRadius: 8,
				padding: 16,
				width: '30%',
			}}
		>
			{/* First row - 2 divs (50% each) */}
			<Flex gap={16} style={{ width: '100%' }}>
				<Flex
					vertical
					justify="center"
					align="center"
					style={{
						border: '1px solid #d9d9d9',
						borderRadius: 8,
						padding: 16,
						flex: 1,
						minHeight: '120px',
						backgroundColor: '#fafafa',
					}}
				>
					<Typography.Text type="secondary">
						Charts Content Example
					</Typography.Text>
				</Flex>
				<Flex
					vertical
					justify="center"
					align="center"
					style={{
						border: '1px solid #d9d9d9',
						borderRadius: 8,
						padding: 16,
						flex: 1,
						minHeight: '120px',
						backgroundColor: '#fafafa',
					}}
				>
					<Typography.Text type="secondary">
						Stats Content Example
					</Typography.Text>
				</Flex>
			</Flex>

			{/* Second row - 1 div (100% width) */}
			<Flex
				vertical
				justify="flex-start"
				align="flex-start"
				style={{
					border: '1px solid #d9d9d9',
					borderRadius: 8,
					padding: 16,
					flex: 1,
					backgroundColor: '#fafafa',
				}}
			>
				<Flex justify="space-between" align="center" style={{ marginBottom: '12px', width: '100%' }}>
					<Typography.Title level={5} style={{ margin: 0 }}>
						Summary Content
					</Typography.Title>
					{onGenerateSummary && (
						<Button 
							type="primary" 
							size="small"
							onClick={onGenerateSummary}
							loading={summaryLoading}
							disabled={summaryLoading}
						>
							{summaryLoading ? 'Generating...' : 'Generate'}
						</Button>
					)}
				</Flex>
				
				{summaryError && (
					<Typography.Text type="danger" style={{ display: 'block', marginBottom: '12px' }}>
						Error: {summaryError}
					</Typography.Text>
				)}
				
				{summaryContent ? (
					<Typography.Paragraph style={{ 
						margin: 0, 
						lineHeight: '1.6',
						fontSize: '13px',
						color: '#333'
					}}>
						{summaryContent}
					</Typography.Paragraph>
				) : (
					<Typography.Text type="secondary" style={{ fontStyle: 'italic' }}>
						{summaryLoading ? 'Generating summary...' : 'Click "Generate" to create an AI-powered overview'}
					</Typography.Text>
				)}
			</Flex>
		</Flex>
	);
}
